import { Trash2 } from "lucide-react";
import { Panel } from "./shared";

export const RedactPanel = ({ redactMode, onModeChange, redactText, onTextChange, redactPages, onPagesChange, redactionCount, onClear, activePicker }) => (
  <Panel testid="redact-controls">
    <div className="border border-hairline rounded-lg bg-page p-3">
      <div className="grid grid-cols-2 gap-1 p-1 bg-white border border-hairline rounded-lg mb-3" data-testid="redact-mode-picker">
        <button data-testid="redact-mode-draw" onClick={() => onModeChange("draw")}
          className={`py-2 min-h-[44px] rounded-full font-mono text-xs transition-colors duration-300 ${redactMode === "draw" ? activePicker : "text-fog hover:text-ink"}`}>
          Draw boxes
        </button>
        <button data-testid="redact-mode-text" onClick={() => onModeChange("text")}
          className={`py-2 min-h-[44px] rounded-full font-mono text-xs transition-colors duration-300 ${redactMode === "text" ? activePicker : "text-fog hover:text-ink"}`}>
          Find text
        </button>
      </div>
      {redactMode === "text" ? (
        <div className="space-y-2">
          <input
            value={redactText}
            onChange={(e) => onTextChange(e.target.value)}
            placeholder="Exact text to remove — name, number or clause"
            data-testid="redact-text-input"
            className="w-full border border-hairline rounded-lg bg-white px-4 py-2.5 font-mono text-xs text-ink placeholder:text-mist focus:outline-none focus:border-azure transition-colors duration-300"
          />
          <input
            value={redactPages}
            onChange={(e) => onPagesChange(e.target.value)}
            placeholder="Optional pages — e.g. 1-3, 5 (blank = all pages)"
            data-testid="redact-pages-input"
            className="w-full border border-hairline rounded-lg bg-white px-4 py-2.5 font-mono text-xs text-ink placeholder:text-mist focus:outline-none focus:border-azure transition-colors duration-300"
          />
        </div>
      ) : (
        <div className="flex items-center justify-between gap-3">
          <p className="font-mono text-[10px] leading-relaxed text-fog">
            Drag across the page previews below. Blackouts are burned into the PDF permanently.
          </p>
          <button data-testid="clear-redactions" onClick={onClear} disabled={!redactionCount}
            className="shrink-0 flex items-center gap-1.5 border border-hairline rounded-full px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.15em] text-mist hover:text-[#FF3333] hover:border-[#FF3333]/40 disabled:opacity-30 transition-colors duration-300">
            <Trash2 className="w-3.5 h-3.5" strokeWidth={1.5} /> Clear
          </button>
        </div>
      )}
    </div>
  </Panel>
);
